<div class="fiche-repondant-available-cas-special">
  <template v-if="casSpeciaux.length > 0">
    <m-message :state="MMessageState.Information">
      <span v-html="$i18next.t('modules.fiche-repondant.form.FicheRepondantAvailableCasSpecial.message.information')" />
    </m-message>
    <template v-for="casSpecial in casSpeciaux">
      <fiche-repondant-available-cas-special-row :cas-special="casSpecial" />
    </template>
  </template>
  <template v-else>
    <m-message :state="MMessageState.Warning">
      <span v-html="$i18next.t('modules.fiche-repondant.form.FicheRepondantAvailableCasSpecial.message.liste_disponible_vide')" />
    </m-message>
  </template>
</div>